<template>
    <div class="admin-service-list">
        <div class="paca-group-list" v-for="(item, index) in serviceList" :key="index" :class="{'is-active': openGroup.find(service => service == item.title)}">
            <div class="paca-group-list__header" @click="itemCollapse(item.title)" >
                <i class="paca-group-list__header-icon"></i>
                <span class="paca-group-list__header-text">
                    <span class="paca-group-list__header-text-nickname">{{item.title}}</span>
                    <span class="paca-group-list__header-text-length">{{item.user_list.length}}</span>
                </span>
            </div>
            <div class="paca-group-list__content">
                <div class="paca-table">
                    <div class="paca-table__header">
                        <div class="paca-table__header-item item-column column-name">名稱</div>
                        <div class="paca-table__header-item item-column column-identity">權限</div>
                    </div>
                    <div class="paca-table__body">
                        <div class="paca-table__body-col" v-for="(secItem, secIndex) in item.user_list" :key="secIndex">
                            <div class="paca-table__body-col-list">
                                <div class="paca-table__body-col-list-item item-column column-name">
                                    <button type="button" class="column-name-button" @click="gotoDetail(secItem.user.nickname)">{{secItem.user.nickname}}</button>
                                </div>
                                <div class="paca-table__body-col-list-item item-column column-identity">{{identityTranslation[secItem.user.identity]}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: "serviceList",
    data(){
        return {
            serviceList: [],
            openGroup: [],
            identityTranslation: {
                is_admin: "管理",
                is_partner: "夥伴",
                is_agent: "代理",
                is_siteowner: "企業",
                is_free_siteowner: "業者"
            },
        }
    },
    methods: {
        itemCollapse(key){
            let indexOfGroup = this.openGroup.findIndex(item => item == key);
            console.log(indexOfGroup);
            if(indexOfGroup != -1){
                this.openGroup.splice(indexOfGroup, 1);
            } else {
                this.openGroup.push(key);
            }
        },
        async getServiceList(){
            let res = await api.getAdminServiceList();
            if(!res.error_status){
                res.forEach(function(item){
                    item.user_list.forEach(function(secItem){
                        let identityList = ["is_admin", "is_partner", "is_agent", "is_siteowner", "is_free_siteowner"];
                        identityList.forEach(function(identity){
                            if(secItem.user[identity] == 1){
                                secItem.user.identity = identity;
                            }
                        })
                    })
                })
                this.serviceList = res;
            }
        },
        gotoDetail(nickname){
            this.$router.push({
                name: 'Complex',
                params: {
                    nickname: nickname
                }
            })
        }
    },
    async activated(){
        await this.getServiceList();
    }
}
</script>